import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { CommonProvider } from '../../providers/common/common';
import { HomePage } from '../home/home';
import { OtpPage } from '../otp/otp';
import { Storage } from '@ionic/storage';
declare var window:any;
/**
 * Generated class for the PasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-password',
  templateUrl: 'password.html',
})
export class PasswordPage {
  errorDisplay:any={};
  errorDisplayFlag:any=false;
  errorCaptchaDisplay:any={};
  password: any;
  mobileNumber:any;
  userAccess:any=0;
  time:any="You have try login on app multiple time! So your login portal has been block for 60 second.";
  disableSubmitButton:any=false;
  captchaenble:any=false;
  captchaInput:any="";
  captcha:any="";
  cifNumber:any="";
  constructor(public navCtrl: NavController,private cp:CommonProvider,
     public navParams: NavParams,private fv : GenericFormValidationProvider,
     public events:Events, private storage: Storage,private loadingCtrl:LoadingController) {
      
  }

  ionViewDidLoad() {
    this.mobileNumber=this.navParams.get("mobile");
    this.cifNumber=this.navParams.get("cifNumber");

    if(sessionStorage.getItem("userAccessCounter") && parseInt(sessionStorage.getItem("userAccessCounter"))>6){
        this.disableSubmitButton=true;
     }else{

      this.disableSubmitButton=false;
     }
     
  }
  generatecp(){
    // let loading = this.loadingCtrl.create({
    //         content: 'Please wait...'
    //       });
      this.captcha=this.cp.generatecp();
      sessionStorage.setItem("code",this.captcha);
      // sessionStorage.setItem("dataCode",res.encryption);
    // this.cp.generatecp().then((res:any)=>{
      
    // })
    
  }
   postFormForValidation(){
      
       let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });
      window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: "password_submit_after"}); 
      //this.generatecp()


      setTimeout(()=>{
         this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[1],true,[]);
       
          if(this.errorDisplay.valid){
            return false;
          }else{
         
             if(this.navParams.get("mobile") || this.navParams.get("cifNumber")){

              loading.present();
              let loginResponce:any;
               if(this.navParams.get("mobile")){
                 loginResponce = this.cp.doLogin(loading,this.navParams.get("mobile"),this.password,true);
               }else{
                 loginResponce = this.cp.doLogin(loading,this.navParams.get("cifNumber"),this.password,false);
               }
              
                    loginResponce.then((resp:any)=>{
                      var res = JSON.parse(resp);
                      if(typeof(res)=='string'){
                         res = JSON.parse(res);
                      }
                      console.log(typeof(res),"token");
                      if(res.hasOwnProperty("Error") && res.Error.ErrorMessage=="Error Password is expired Please reset"){
                        loading.dismiss();
                        //sessionStorage.setItem("successtoken",res.successEnc.successEnc); 
                        this.errorDisplay.password = "Your password has expired. ";
                        this.errorDisplayFlag=true;
                      }
                      else if(res.Payload.responseMessage=="SUCCESS" || res.Payload.Message=="SUCCESS"){
                        loading.dismiss();
                        localStorage.setItem("token",res.accesstoken)
                        var date=new Date();
                        //sessionStorage.setItem("successtoken",res.successEnc.successEnc);
                        localStorage.setItem("_current",date.getTime().toString())
                        this.storage.set('token',res.accesstoken)
                        if(localStorage.getItem("token")){
                          let user:any=localStorage.getItem("token");
                          this.events.publish('user:created',user , Date.now());
                        }
                        if(this.mobileNumber){
                          this.navCtrl.setRoot(HomePage,{mobile:this.mobileNumber});
                        }else{
                          this.navCtrl.setRoot(HomePage,{cifNumber:this.cifNumber});
                          
                          
                        }
                      }
                      else{
                         loading.dismiss();
                         this.errorDisplay.password = "Invalid credentials,Please try again!";
                         ////console.log(parseInt(sessionStorage.getItem("userAccessCounter")));
                         if(!sessionStorage.getItem("userAccessCounter")){
                          this.userAccess = this.userAccess+1;
                          sessionStorage.setItem("userAccessCounter",this.userAccess) 
                         }else if(sessionStorage.getItem("userAccessCounter") && parseInt(sessionStorage.getItem("userAccessCounter"))<7){
                          this.userAccess = this.userAccess+1;
                          sessionStorage.setItem("userAccessCounter",this.userAccess) 
                         }else{
                          this.disableSubmitButton=true;
                         }
                         
                      }
                      
                    }).catch(err => {
                       console.log(err,"test ");
                      loading.dismiss();
                      this.errorDisplay.password = "Invalid credentials,Please try again!";
                       this.errorDisplay.password = "Invalid credentials,Please try again!";
                         ////console.log(parseInt(sessionStorage.getItem("userAccessCounter")));
                         if(!sessionStorage.getItem("userAccessCounter")){
                          this.userAccess = this.userAccess+1;
                          sessionStorage.setItem("userAccessCounter",this.userAccess) 
                         }else if(sessionStorage.getItem("userAccessCounter") && parseInt(sessionStorage.getItem("userAccessCounter"))<7){
                          this.userAccess = this.userAccess+1;
                          sessionStorage.setItem("userAccessCounter",this.userAccess) 
                         }else{
                          
                          this.disableSubmitButton=true;
                          setTimeout(()=>{
                              this.disableSubmitButton=false;
                              sessionStorage.clear();
                          },60000)
                         }
                    })
                   
              }else{
              loading.dismiss();
              this.errorDisplay.password = "Mobile number is required";
               
             }
          }
        },1000)
    }
  // postFormForValidation(){
    
  //    let loading = this.loadingCtrl.create({
  //           content: 'Please wait...'
  //         });
  //   window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: "password_submit_after"}); 
  //   this.generatecp()


  //   setTimeout(()=>{
  //      this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[1],true,[]);
     
  //       if(this.errorDisplay.valid){
  //         return false;
  //       }else{
       
  //          if(this.navParams.get("mobile")){

  //             loading.present();
  //           // try {
  //             let loginResponce = this.cp.doLogin(loading,this.navParams.get("mobile"),this.password);
  //             loginResponce.then((res:any)=>{
  //               var res = JSON.parse(res);
  //               if(res.hasOwnProperty("Error") && res.Error.ErrorMessage=="Error Password is expired Please reset"){
  //                     loading.dismiss();
  //                     sessionStorage.setItem("successtoken",res.successEnc.successEnc); 
  //                     this.errorDisplay.password = "Your password has expired. ";
  //                     this.errorDisplayFlag=true;
  //               }
  //               else if(res.Payload.responseMessage=="SUCCESS"){
  //                 loading.dismiss();
  //                 localStorage.setItem("token",res.accesstoken)
  //                 var date=new Date();
                   
  //                 localStorage.setItem("_current",date.getTime().toString())
  //                 this.storage.set('token',res.accesstoken)
  //                 if(localStorage.getItem("token")){
  //                   let user:any=localStorage.getItem("token");
  //                   this.events.publish('user:created',user , Date.now());
  //                 }
                  
  //                 this.navCtrl.setRoot(HomePage,{mobile:this.mobileNumber});
  //               }else{
  //                  loading.dismiss();
  //                  this.errorDisplay.password = "Invalid credentials,Please try again!";
  //                  ////console.log(parseInt(sessionStorage.getItem("userAccessCounter")));
  //                  if(!sessionStorage.getItem("userAccessCounter")){
  //                   this.userAccess = this.userAccess+1;
  //                   sessionStorage.setItem("userAccessCounter",this.userAccess) 
  //                  }else if(sessionStorage.getItem("userAccessCounter") && parseInt(sessionStorage.getItem("userAccessCounter"))<7){
  //                   this.userAccess = this.userAccess+1;
  //                   sessionStorage.setItem("userAccessCounter",this.userAccess) 
  //                  }else{
  //                   this.disableSubmitButton=true;
  //                  }
                   
  //               }
                
  //             }).catch(err => {
  //               // //////console.log(err);
  //               loading.dismiss();
  //               this.errorDisplay.password = "Invalid credentials,Please try again!";
  //                this.errorDisplay.password = "Invalid credentials,Please try again!";
  //                  ////console.log(parseInt(sessionStorage.getItem("userAccessCounter")));
  //                  if(!sessionStorage.getItem("userAccessCounter")){
  //                   this.userAccess = this.userAccess+1;
  //                   sessionStorage.setItem("userAccessCounter",this.userAccess) 
  //                  }else if(sessionStorage.getItem("userAccessCounter") && parseInt(sessionStorage.getItem("userAccessCounter"))<7){
  //                   this.userAccess = this.userAccess+1;
  //                   sessionStorage.setItem("userAccessCounter",this.userAccess) 
  //                  }else{
                    
  //                   this.disableSubmitButton=true;
  //                   setTimeout(()=>{
  //                       this.disableSubmitButton=false;
  //                       sessionStorage.clear();
  //                   },60000)
  //                  }
  //             })
             
            
  //          }else{
  //           loading.dismiss();
  //           this.errorDisplay.password = "Mobile number is required";
             
  //          }
  //       }
  //     },1000)
  //   }
    goToCancel(){
      this.captchaenble=false
      this.generatecp();
    }
    enableCpatcha(){
      this.captchaenble=true
      this.generatecp();
    }

    goToForgotPassword(mobileNumber){
      this.errorCaptchaDisplay.captcha="";
      if(this.captchaInput){
        if(this.cp.checkCaptcha(this.captchaInput,sessionStorage.getItem("code")))
        {
          this.errorCaptchaDisplay.captcha="";
          this.navCtrl.push(OtpPage,{mobile:this.navParams.get("mobile"),type:"forgot",captcha:this.captchaInput})
        }else{
          this.errorCaptchaDisplay.captcha="Invalid captcha.";
          this.generatecp()
        }
      }else{
        this.errorCaptchaDisplay.captcha="Invalid captcha.";
          //alert("Invalid captcha.")
          this.generatecp()
        }
    }
    
}



// WEBPACK FOOTER //
// ./src/pages/password/password.ts